import createApiClient from './apiClient';

const studentApi = createApiClient(process.env.REACT_APP_ATHENIAN_STUDENT_SERVICE_URL);

export const getStudentFiles = (studentId, params) =>
  studentApi.get(`/${studentId}/files`, { params });

export const getStudentFile = (studentId, fileId) =>
  studentApi.get(`/${studentId}/files/${fileId}`);

export const uploadStudentFiles = (studentId, formData) =>
  studentApi.post(`/${studentId}/files`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const updateStudentFile = (studentId, fileId, data) =>
  studentApi.put(`/${studentId}/files/${fileId}`, data);

export const deleteStudentFile = (studentId, fileId) =>
  studentApi.delete(`/${studentId}/files/${fileId}`);

export const bulkDeleteStudentFiles = (studentId, fileIds) =>
  studentApi.delete(`/${studentId}/files`, { data: { file_ids: fileIds } });

export const getFileView = (studentId, fileId, page) => {
  const params = page != null ? `?page=${page}` : '';
  return studentApi.get(`/${studentId}/files/${fileId}/view${params}`);
};

/** Word + checkbox boxes of one page, used to highlight a citation in the source panel. */
export const getPageGeometry = (studentId, fileId, page) =>
  studentApi.get(`/${studentId}/files/${fileId}/page-geometry`, { params: { page } });

export const streamStudentFile = (studentId, fileId, config = {}) =>
  studentApi.get(`/${studentId}/files/${fileId}/stream`, { responseType: 'blob', ...config });

export const downloadStudentFile = (studentId, fileId) =>
  studentApi.get(`/${studentId}/files/${fileId}/download`, { responseType: 'blob' });

export const bulkDownloadStudentFiles = (studentId, fileIds) =>
  studentApi.post(`/${studentId}/files/download`, { file_ids: fileIds }, { responseType: 'blob' });

function filenameFromContentDisposition(header, fallback) {
  if (!header) return fallback;
  const utf8 = /filename\*=UTF-8''([^;]+)/i.exec(header);
  if (utf8?.[1]) {
    try {
      return decodeURIComponent(utf8[1].trim());
    } catch {
      return utf8[1].trim();
    }
  }
  const plain = /filename="?([^";]+)"?/i.exec(header);
  return plain?.[1]?.trim() || fallback;
}

export async function triggerFileDownload(studentId, fileId, fileName) {
  const { data } = await downloadStudentFile(studentId, fileId);
  const url = window.URL.createObjectURL(data);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName || 'download';
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

export async function triggerBulkFileDownload(studentId, fileIds, fallbackName = 'download.zip') {
  const { data, headers } = await bulkDownloadStudentFiles(studentId, fileIds);
  const fileName = filenameFromContentDisposition(
    headers?.['content-disposition'] || headers?.['Content-Disposition'],
    fallbackName,
  );
  const url = window.URL.createObjectURL(data);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}
